import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { onEnterAction } from '../utils/a11y';

export interface Props {
  iconName: IconProp;
  link: string;
  label: string;
  eventName: string;
  handleLinkClicked: (eventName: string, params?: Record<string, unknown>) => Promise<void>;
  classes?: string;
}

export const IconLink = ({ iconName, link, label, eventName, handleLinkClicked, classes }: Props): JSX.Element => (
  <a
    className={`inline-block align-middle w-1/6 text-slate-500 active:sapphire ${classes}`}
    href={link}
    onClick={async (): Promise<void> => handleLinkClicked(eventName)}
    onKeyDown={(e): void => onEnterAction(e, async (): Promise<void> => handleLinkClicked(eventName))}
    role='button'
    tabIndex={0}
  >
    <FontAwesomeIcon icon={iconName} className='h-5' />
    <div className='text-xs'>{label}</div>
  </a>
);
